import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";

import {api,API_URL} from '../../actions/_request';

import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import FAprint from 'react-icons/lib/fa/print';
import Fasearch from 'react-icons/lib/fa/search';
export default class EntragasDiarias extends React.Component{
	constructor(props){
		super(props);
		this.state={
			data : [],
			fetch : false,
		}
	}
	documento(tipo){
		let ruta='/documento'+this.props.datos+'/'+tipo;
		console.log('ruta--->',ruta);
		if(tipo==1){
            window.open(`${API_URL}${ruta}`);
            }else{
              api().post(ruta, []).then(function(response) {

                if(response.status === 200) {
                  var a = document.createElement("a");
                  a.href = response.data.file; 
                  a.download = response.data.name;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                }
                else{
                }

              })
              .catch(function(error) {
               console.log('ruta Error--->',ruta);
              });

            }
	}

	componentDidMount(){
		let self = this;
	

		api().get(this.props.datos)
        .then(function(response)
        {
            self.setState({
                data : response.data,
                fetch : true
            });  
		});
	}

	render(){
		let {data}= this.state;
		console.log(data)
		return(
			<Card>
			<CardTitle>
			
				
            
            </CardTitle>
			<CardBlock>

			<div className='Row mb-4'>
			<div className="col-12 text-right">
				<label><br/></label><br/>
				<Button color='primary' onClick={(evt)=> this.documento(1)}> PDF </Button>
				{'  '}
				<Button color='success' onClick={(evt)=> this.documento(2)}> Excel </Button>
		    </div>
		    </div>
				
	            {

				fetch &&
				<ReactTable
					data= {this.state.data}
		            className = "-striped -highlight"
		            columns   = {[ 
		            	{Header: 'Fecha ', accessor: 'fecha_finalizado'},
			            {Header: 'Clave', accessor: 'clave'},
			            {Header: 'Cliente', accessor: 'tecnico'},
			            {Header: 'Cobro', accessor: 'cobro'},
			            {Header: 'Tipo Pago', accessor: 'tipo_pago_text'},
			            {Header: 'total', accessor: 'total_format'},
		            ]}
		            SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Tecnicos:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Creo Ticket:</dt>
                                                <dd className="col-sm-9">{row.original.creador}</dd>

                                                 <dt className="col-sm-3 text-truncate">Tecnico Asignado</dt>
                                                <dd className="col-sm-9">{row.original.asignado}</dd>

                                                <dt className="col-sm-3 text-truncate">Cobro:</dt>
                                                <dd className="col-sm-9">{row.original.cobro}</dd>                       

                                            </dl>
                                            </div>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Cliente:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Razon Social:</dt>
                                                <dd className="col-sm-9">{row.original.empresa}</dd>

                                                 <dt className="col-sm-3 text-truncate">Telefono</dt>
                                                <dd className="col-sm-9">{row.original.telefono}</dd>

                                                <dt className="col-sm-3 text-truncate">Contacto:</dt>
                                                <dd className="col-sm-9">{row.original.contacto}</dd>                       

                                            </dl>
                                            </div>
                                              
                                            </div>




                                             <h1 className="h4 text-uppercase">Ticket:</h1>

                                              
                                                  <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha y hora</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.created_at +' '+row.original.hora}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Fecha de Pago</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.fecha_pago }}></dd>
                                                    <dt className="col-sm-3 text-truncate">Factura</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.factura}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Remision</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.remision}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripción Recepción</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Descripción Proceso/ Diagnostico</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion_proceso}}></dd>
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dt className="col-sm-3 text-truncate">Descripción de Cancelado</dt>
                                                    }
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.motivo_cancelado}}></dd>
                                                    }
                                                  </dl>
                                                  {
                                                      (row.original.proceso_id===5)&&
                                                   <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.fecha}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Tecnico de Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.usuario}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripcion Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.motivo}}></dd>
                                                   
                                                   
                                                  </dl>
                                                }
                                                

                                            


                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Iva</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>
                                                   <td>{item.subtotal_formato}</td>
                                                   <td>{item.iva_formato}</td>
                                                   <td>{item.total_formato}</td>   
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
		            filterable 
		            defaultPageSize={10} 

				/>
			}
			</CardBlock>
			</Card>
			)
	}
}


// WEBPACK FOOTER //
// ./src/views/reportes/reportessinpv.js